var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBalconies = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 36,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#balconies_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#6E3037",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M4.941 18h11.294M2.117 32.472V2.825c0-1.17.948-2.118 2.118-2.118h27.53c1.169 0 2.117.948 2.117 2.118v29.647"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#6E3037",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "m4.941 3.531 11.294 4.236v20.47L4.941 32.472zm0 0H31.06v28.941M10.588 30.354V5.648M31.058 18H19.764"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#6E3037",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M31.058 3.531 19.764 7.767v20.47l11.294 4.235M25.412 5.648v24.706"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFCAA1",
  d: "M2.118 36A2.12 2.12 0 0 1 0 33.884a2.12 2.12 0 0 1 2.118-2.117h31.764A2.12 2.12 0 0 1 36 33.883a2.12 2.12 0 0 1-2.118 2.118z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "balconies_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h36v36H0z"
})))));
export default SvgBalconies;